@if ({
  productPrice: productPriceItem$ | async,
  product: product$ | async
  }; as type) {
  @if (userLoggedIn$ | async) {
    @if (wishListEntries$ | async; as entries) {
      @if (hasStock && type.product && type.productPrice?.listPrice && type.productPrice?.listPrice.value > 0) {
        @if (getProductInWishList(type.product, entries); as entry) {
          <div
            >
            <button
              class="btn btn-link button-remove cx-action-link"
              (click)="remove(entry)"
              [disabled]="loading$ | async"
              >
              <cx-icon [type]="iconTypes.HEART" class="mr-2"></cx-icon>
              <span class="button-text">{{
                'addToWishList.remove' | cxTranslate
              }}</span>
            </button>
          </div>
        } @else {
          <button
            class="btn btn-link button-add cx-action-link"
            (click)="add(type.product)"
            [disabled]="loading$ | async"
            >
            <cx-icon [type]="iconTypes.EMPTY_HEART" class="mr-2"></cx-icon>
            <span class="button-text">{{
              'addToWishList.add' | cxTranslate
            }}</span>
          </button>
        }
      }
    }
  } @else {
    @if (hasStock && type.product && type.productPrice?.listPrice && type.productPrice?.listPrice.value > 0) {
      <a
        class="btn btn-link button-add-link cx-action-link"
        [routerLink]="{ cxRoute: 'login' } | cxUrl"
        >
        <cx-icon [type]="iconTypes.EMPTY_HEART"></cx-icon>
        <span class="button-text">{{
          'addToWishList.anonymous' | cxTranslate
        }}</span>
      </a>
    }
  }
}
